module.exports = __webpack_public_path__ + "static/img/plmb.2942b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plmb.jpg
// module id = 3NYD
// module chunks = 73